import { FlowChart } from "./components/FlowChart/FlowChart";

import "./App.css";

function App() {
  return (
    <div className="App">
      <FlowChart />
    </div>
  );
}

export default App;
